export default __webpack_public_path__ + "static/media/shel shapiro.18076e88.jpg";